import anime from "animejs";
import { appUtils, configs } from "..";
import { app } from "../appProduct";
import { TypeDirFactor } from "../data";
import { LoaderEvents } from "../loader";
import PgProductItem from "./pgProductItem";

export default class PgProduct {
    private _cont: HTMLElement;
    private _current: PgProductItem;
    private _btnNext: HTMLElement;
    private _btnPrev: HTMLElement;

    get current() { return this._current; }
    get cont() { return this._cont; }

    constructor() {
        this._cont = document.body;

        (this._btnPrev = this._cont.querySelector(".product-detail-arrow.arrow-left"))
            .addEventListener("click", () => this.show(this._current.index - 1, -1));
        (this._btnNext = this._cont.querySelector(".product-detail-arrow.arrow-right"))
            .addEventListener("click", () => this.show(this._current.index + 1, 1));

        window.addEventListener('keyup', (e) => {
            switch (e.key) {
                case "ArrowLeft":
                    this.show(this._current.index - 1, -1);
                    break;
                case "ArrowRight":
                    this.show(this._current.index + 1, 1);
                    break;
            }
        })
    }

    init() {
        this.show(this.getIndexById(parseInt(app.header.searchParams.get("id"))));

        window.addEventListener("resize", () => this._onResize());
    }

    getIndexById(id: number) {
        return app.products.data.products.findIndex(item => item.id == id);
    }

    show(index: number, dir: TypeDirFactor = 0) {
        const newIndex = appUtils.clamp(index, 0, app.products.data.products.length - 1);
        if (this._current && newIndex == this._current.index)
            return;

        const prev = this._current;
        if (prev && prev.animating)
            return;

        this._current = new PgProductItem(newIndex);
        this._current.addImagesToLoad(app.loader);
        app.loader.once(LoaderEvents.Complete, () => {
            if (prev)
                prev.hide(dir);

            this._current.show(dir);

            this._btnPrev.classList.remove("disabled");
            this._btnNext.classList.remove("disabled");
            if (newIndex < 1) this._btnPrev.classList.add("disabled");
            if (newIndex >= app.products.data.products.length - 1) this._btnNext.classList.add("disabled");

            app.header.setSearchParam("id", this._current.data.id.toString());
        }).load();
    }

    setHeight(dirFactor: number) {
        if (dirFactor == 0)
            this._cont.style.height = this._current.cont.offsetHeight + "px";
        else
            anime({
                targets: this._cont,
                height: this._current.cont.offsetHeight,
                duration: configs.animDurPageChange, easing: "linear"
            });
    }

    private _onResize() {
        this.setHeight(0);
    }
}